/*
  SMBF lead-funnel copy.
  SMBF is the high-intent entry point. The commercial service is The Bitcoin Adviser:
  collaborative security implementation and operational support for client-controlled Bitcoin.
  SMSF setup, rollover, tax, legal, financial advice, and compliance sit with licensed professionals.
*/

export const CONTENT = {
  hero: {
    eyebrow: "Self-Managed Bitcoin Fund · Australia",
    title: ["Want to buy Bitcoin", "in an SMSF?"],
    lede:
      "Start with the practical pathway: SMSF setup, rollover, client-controlled Bitcoin, records, and continuity.",
    primary: "Book a pathway call",
    secondary: "See the pathway",
    micro: "15-minute call - no obligation - general information, not advice",
  },

  // How the call works - this is the funnel.
  callSteps: [
    [
      "Book a pathway call",
      "Use the short contact form to tell us where you are now: existing super, SMSF status, trustee structure, and whether you already have professional advisers involved.",
    ],
    [
      "Map the right roles",
      "Licensed professionals handle SMSF setup, rollover, tax, legal, advice, and compliance. The Bitcoin Adviser handles collaborative security implementation and operational support for client-controlled Bitcoin.",
    ],
    [
      "Proceed with the right process",
      "If the pathway fits, the fund, rollover, Bitcoin purchase process, records, and continuity plan move forward with the right people involved.",
    ],
  ],
};
